import React from 'react'

import { Banner } from '@fourthwall/components'

import type { PaymentMethodItem } from '../../PaymentMethods.types'
import { PaymentMethodsList } from '../../components/PaymentMethodsList/PaymentMethodsList'
import * as S from './ShopPaymentMethodsView.styled'

type ShopPaymentMethodsViewProps = {
  paymentMethodsProps: PaymentMethodItem[]
  errorBanner?: string
}

export const ShopPaymentMethodsView = ({
  paymentMethodsProps,
  errorBanner,
}: ShopPaymentMethodsViewProps) => (
  <div>
    {errorBanner && (
      <S.BannerContainer>
        <Banner appearance="danger">{errorBanner}</Banner>
      </S.BannerContainer>
    )}
    <PaymentMethodsList paymentMethods={paymentMethodsProps} />
  </div>
)
